import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Grievance, GrievanceCreate, GrievanceFilter } from '../data/grievance';

export function createGrievanceService(client: AxiosInstance) {
  return createCrudService<Grievance, GrievanceCreate, GrievanceFilter>(
    client,
    '/hrm/Grievance',
    'id',
  );
}

export type GrievanceService = CrudService<Grievance, GrievanceCreate, GrievanceFilter>;
